/**
 * KST(Asia/Seoul) 기준 날짜·시간 포맷터.
 * 브라우저 환경의 로컬타임존(UTC가 될 수도 있음)에 의존하지 않고
 * 항상 한국 시간으로 일관되게 표시한다.
 *
 * 입력은 ISO 문자열 / Date / null 모두 허용한다.
 */

const KST = 'Asia/Seoul';

function _toDate(input) {
  if (input == null || input === '') return null;
  if (input instanceof Date) {
    return Number.isNaN(input.getTime()) ? null : input;
  }
  let s = String(input);
  // 백엔드는 datetime.now(timezone.utc)로 UTC datetime을 생성하지만 MongoDB Motor가
  // tzinfo를 떼어 naive UTC로 저장 → isoformat 응답에 'Z' 등 timezone suffix가 빠짐.
  // 'T' 형태 ISO인데 suffix가 없으면 UTC로 강제 해석한다 (브라우저 로컬타임 오해석 방지).
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s) && !/[Zz]|[+-]\d{2}:?\d{2}$/.test(s)) {
    s += 'Z';
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "2026. 6. 2. 오후 8:20:00" — 날짜+시간 (초 포함) */
export function fmtKstDateTime(input, withSeconds = true) {
  const d = _toDate(input);
  if (!d) return '-';
  return d.toLocaleString('ko-KR', {
    timeZone: KST,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
    ...(withSeconds ? { second: '2-digit' } : {}),
    hour12: false,
  });
}

/** "2026.06.02 20:20" — 컴팩트 표시 */
export function fmtKstCompact(input) {
  const d = _toDate(input);
  if (!d) return '-';
  const parts = new Intl.DateTimeFormat('ko-KR', {
    timeZone: KST,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(d).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
  return `${parts.year}.${parts.month}.${parts.day} ${parts.hour}:${parts.minute}`;
}

/** "2026. 6. 2." — 날짜만 */
export function fmtKstDate(input) {
  const d = _toDate(input);
  if (!d) return '-';
  return d.toLocaleDateString('ko-KR', { timeZone: KST });
}

/** "20:20" — 시간만 */
export function fmtKstTime(input, withSeconds = false) {
  const d = _toDate(input);
  if (!d) return '-';
  return d.toLocaleTimeString('ko-KR', {
    timeZone: KST,
    hour: '2-digit', minute: '2-digit',
    ...(withSeconds ? { second: '2-digit' } : {}),
    hour12: false,
  });
}

/** "6월 2일 (화)" — 월/일 + 요일 */
export function fmtKstMonthDay(input) {
  const d = _toDate(input);
  if (!d) return '-';
  return d.toLocaleDateString('ko-KR', {
    timeZone: KST, month: 'long', day: 'numeric', weekday: 'short',
  });
}
